module.exports = __webpack_public_path__ + "static/media/me.50c96b58.png";